<div class="hierarchy-container">
  <!-- Header -->
  <div class="hierarchy-header">
    <button class="btn-back" (click)="goBack()" title="Go back">
      <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M19 12H5M12 19L5 12L12 5" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"/>
      </svg>
      <span>Back</span>
    </button>
    <h1>Family Hierarchy</h1>
  </div>

  <!-- Loading State -->
  <div *ngIf="isLoading" class="loading-container">
    <div class="loading-spinner"></div>
    <p>Loading hierarchy...</p>
  </div>

  <!-- Hierarchy Tree -->
  <div *ngIf="!isLoading && hierarchyData" class="hierarchy-tree">
    
    <!-- Parents Level -->
    <div class="hierarchy-level parents-level">
      <div class="level-label parents-label">Parents</div>
      <div class="relatives-row">
        <div class="parent-couple-card" 
             *ngIf="hierarchyData.parents.length > 0"
             [class.selected]="isParentSelected()"
             (click)="selectParentCouple()">
          <div class="parent-couple-container">
            <!-- Father -->
            <div class="parent-individual" *ngIf="getParentByGender('Male') as father">
              <div class="relative-avatar" [attr.data-tooltip]="'Click on image to select this relative'">
                <img *ngIf="father.profileImageUrl" class="avatar-img" [src]="father.profileImageUrl" alt="Father avatar" (click)="selectAsCurrent(father); $event.stopPropagation()" />
                <div class="avatar-circle" *ngIf="!father.profileImageUrl" (click)="selectAsCurrent(father); $event.stopPropagation()">
                  {{ getInitials(father) }}
                </div>
              </div>
              <div class="relative-info">
                <h3>
                  <svg *ngIf="father.isDeceased" class="deceased-icon" width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M12 2L13.09 8.26L20 9L13.09 9.74L12 16L10.91 9.74L4 9L10.91 8.26L12 2Z" fill="currentColor"/>
                    <path d="M19 15L19.5 17.5L22 18L19.5 18.5L19 21L18.5 18.5L16 18L18.5 17.5L19 15Z" fill="currentColor"/>
                    <path d="M5 15L5.5 17.5L8 18L5.5 18.5L5 21L4.5 18.5L2 18L4.5 17.5L5 15Z" fill="currentColor"/>
                  </svg>
                  {{ father.firstName }} <span *ngIf="father.middleName">{{ father.middleName }}</span> {{ father.lastName }}
                </h3>
                <p class="age-info" *ngIf="!father.isDeceased">{{ calculateAge(father.dateOfBirth) }} years old</p>
                <p class="deceased-info" *ngIf="father.isDeceased">Deceased</p>
                <p>Father</p>
              </div>
            </div>
            
            <!-- Marriage Symbol -->
            <div class="marriage-symbol" *ngIf="getParentByGender('Male') && getParentByGender('Female')">
              <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M12 2L13.09 8.26L22 9L13.09 9.74L12 16L10.91 9.74L2 9L10.91 8.26L12 2Z" fill="currentColor"/>
                <circle cx="12" cy="12" r="2" fill="currentColor"/>
              </svg>
            </div>
            
            <!-- Mother -->
            <div class="parent-individual" *ngIf="getParentByGender('Female') as mother">
              <div class="relative-avatar" [attr.data-tooltip]="'Click on image to select this relative'">
                <img *ngIf="mother.profileImageUrl" class="avatar-img" [src]="mother.profileImageUrl" alt="Mother avatar" (click)="selectAsCurrent(mother); $event.stopPropagation()" />
                <div class="avatar-circle" *ngIf="!mother.profileImageUrl" (click)="selectAsCurrent(mother); $event.stopPropagation()">
                  {{ getInitials(mother) }}
                </div>
              </div>
              <div class="relative-info">
                <h3>
                  <svg *ngIf="mother.isDeceased" class="deceased-icon" width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M12 2L13.09 8.26L20 9L13.09 9.74L12 16L10.91 9.74L4 9L10.91 8.26L12 2Z" fill="currentColor"/>
                    <path d="M19 15L19.5 17.5L22 18L19.5 18.5L19 21L18.5 18.5L16 18L18.5 17.5L19 15Z" fill="currentColor"/>
                    <path d="M5 15L5.5 17.5L8 18L5.5 18.5L5 21L4.5 18.5L2 18L4.5 17.5L5 15Z" fill="currentColor"/>
                  </svg>
                  {{ mother.firstName }} <span *ngIf="mother.middleName">{{ mother.middleName }}</span> {{ mother.lastName }}
                </h3>
                <p class="age-info" *ngIf="!mother.isDeceased">{{ calculateAge(mother.dateOfBirth) }} years old</p>
                <p class="deceased-info" *ngIf="mother.isDeceased">Deceased</p>
                <p>Mother</p>
              </div>
            </div>
          </div>
          
          <!-- Actions for the parent couple -->
          <div class="relative-actions">
            <button class="action-icon-btn" (click)="viewParentCouple()" title="View Parents">
              <svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M1 12S5 4 12 4S23 12 23 12S19 20 12 20S1 12 1 12Z" stroke="currentColor" stroke-width="2"/>
                <circle cx="12" cy="12" r="3" stroke="currentColor" stroke-width="2"/>
              </svg>
            </button>
            <button class="action-icon-btn" (click)="openChat(hierarchyData.parents[0])" title="Chat" *ngIf="hierarchyData.parents.length > 0">
              <svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z" stroke="currentColor" stroke-width="2"/>
              </svg>
            </button>
            <button class="action-icon-btn primary" (click)="addRelativeWithParent(hierarchyData.parents[0])" title="Add Child" *ngIf="hierarchyData.parents.length > 0">
              <svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <line x1="12" y1="5" x2="12" y2="19" stroke="currentColor" stroke-width="2"/>
                <line x1="5" y1="12" x2="19" y2="12" stroke="currentColor" stroke-width="2"/>
              </svg>
            </button>
          </div>
        </div>
      </div>
    </div>

    <!-- Connection Line from Parents to Current -->
    <div class="connection-line vertical" *ngIf="hierarchyData.parents.length > 0"></div>

    <!-- Current Person Level -->
    <div class="hierarchy-level current-level">
      <div class="current-person-container">
        <!-- Siblings (Left) -->
        <div class="siblings-section" 
             [class.no-spouse]="!hierarchyData.spouse"
             *ngIf="hierarchyData.siblings.length > 0">
          <div class="level-label siblings-label">
            <span>Siblings</span>
            <span class="count-badge" *ngIf="hierarchyData.siblings.length > 1">{{ hierarchyData.siblings.length }}</span>
          </div>
          <div class="siblings-scroll-container">
            <div class="siblings-scroll-wrapper">
              <div class="siblings-scroll-content">
                <div *ngFor="let sibling of visibleSiblings" 
                     class="relative-card sibling-card" 
                     [class.selected]="isSelected(sibling)"
                     (click)="selectRelative(sibling)">
                  <div class="relative-avatar" [attr.data-tooltip]="'Click on image to select this relative'">
                    <img *ngIf="sibling.profileImageUrl" class="avatar-img" [src]="sibling.profileImageUrl" alt="Sibling avatar" (click)="selectAsCurrent(sibling); $event.stopPropagation()" />
                    <div class="avatar-circle" *ngIf="!sibling.profileImageUrl" (click)="selectAsCurrent(sibling); $event.stopPropagation()">
                      {{ getInitials(sibling) }}
                    </div>
                  </div>
                  <div class="relative-info">
                    <h3>
                      <svg *ngIf="sibling.isDeceased" class="deceased-icon" width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M12 2L13.09 8.26L20 9L13.09 9.74L12 16L10.91 9.74L4 9L10.91 8.26L12 2Z" fill="currentColor"/>
                        <path d="M19 15L19.5 17.5L22 18L19.5 18.5L19 21L18.5 18.5L16 18L18.5 17.5L19 15Z" fill="currentColor"/>
                        <path d="M5 15L5.5 17.5L8 18L5.5 18.5L5 21L4.5 18.5L2 18L4.5 17.5L5 15Z" fill="currentColor"/>
                      </svg>
                      {{ sibling.firstName }} <span *ngIf="sibling.middleName">{{ sibling.middleName }}</span> {{ sibling.lastName }}
                    </h3>
                    <p class="age-info" *ngIf="!sibling.isDeceased">{{ calculateAge(sibling.dateOfBirth) }} years old</p>
                    <p class="deceased-info" *ngIf="sibling.isDeceased">Deceased</p>
                    <p>{{ getRelationshipType(sibling, 'sibling') }}</p>
                  </div>
                  <div class="relative-actions">
                    <button class="action-icon-btn" (click)="viewRelative(sibling)" title="View Details">
                      <svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M1 12S5 4 12 4S23 12 23 12S19 20 12 20S1 12 1 12Z" stroke="currentColor" stroke-width="2"/>
                        <circle cx="12" cy="12" r="3" stroke="currentColor" stroke-width="2"/>
                      </svg>
                    </button>
                    <button class="action-icon-btn" (click)="openChat(sibling)" title="Chat">
                      <svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z" stroke="currentColor" stroke-width="2"/>
                      </svg>
                    </button>
                    <button class="action-icon-btn primary" (click)="addRelativeWithParent(sibling)" title="Add Child">
                      <svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <line x1="12" y1="5" x2="12" y2="19" stroke="currentColor" stroke-width="2"/>
                        <line x1="5" y1="12" x2="19" y2="12" stroke="currentColor" stroke-width="2"/>
                      </svg>
                    </button>
                  </div>
                </div>
              </div>
            </div>
            <!-- Navigation indicators -->
            <div class="scroll-indicator left" 
                 *ngIf="hierarchyData.siblings.length > siblingsPerPage" 
                 [class.disabled]="!canGoToPreviousSiblings()"
                 (click)="previousSiblings()">
              <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M15 18L9 12L15 6" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
              </svg>
            </div>
            <div class="scroll-indicator right" 
                 *ngIf="hierarchyData.siblings.length > siblingsPerPage" 
                 [class.disabled]="!canGoToNextSiblings()"
                 (click)="nextSiblings()">
              <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M9 18L15 12L9 6" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
              </svg>
            </div>
          </div>
        </div>

        <!-- Current Person (Center) -->
        <div class="current-person">
          <div class="current-avatar">
            <img *ngIf="hierarchyData.current.profileImageUrl" class="avatar-img current" [src]="hierarchyData.current.profileImageUrl" alt="Current avatar" (click)="selectAsCurrent(hierarchyData.current)" />
            <div class="avatar-circle current" *ngIf="!hierarchyData.current.profileImageUrl" (click)="selectAsCurrent(hierarchyData.current)">
              {{ getInitials(hierarchyData.current) }}
            </div>
          </div>
          <div class="current-info">
            <h2>
              <svg *ngIf="hierarchyData.current.isDeceased" class="deceased-icon current-deceased-icon" width="18" height="18" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M12 2L13.09 8.26L20 9L13.09 9.74L12 16L10.91 9.74L4 9L10.91 8.26L12 2Z" fill="currentColor"/>
                <path d="M19 15L19.5 17.5L22 18L19.5 18.5L19 21L18.5 18.5L16 18L18.5 17.5L19 15Z" fill="currentColor"/>
                <path d="M5 15L5.5 17.5L8 18L5.5 18.5L5 21L4.5 18.5L2 18L4.5 17.5L5 15Z" fill="currentColor"/>
              </svg>
              {{ hierarchyData.current.firstName }} <span *ngIf="hierarchyData.current.middleName">{{ hierarchyData.current.middleName }}</span> {{ hierarchyData.current.lastName }}
            </h2>
            <p class="age-info" *ngIf="!hierarchyData.current.isDeceased">{{ calculateAge(hierarchyData.current.dateOfBirth) }} years old</p>
            <p class="deceased-info" *ngIf="hierarchyData.current.isDeceased">Deceased</p>
            <p>Current Person</p>
          </div>
          <div class="current-actions">
            <button class="action-icon-btn" (click)="viewRelative(hierarchyData.current)" title="View Details">
              <svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M1 12S5 4 12 4S23 12 23 12S19 20 12 20S1 12 1 12Z" stroke="currentColor" stroke-width="2"/>
                <circle cx="12" cy="12" r="3" stroke="currentColor" stroke-width="2"/>
              </svg>
            </button>
            <button class="action-icon-btn" (click)="openChat(hierarchyData.current)" title="Chat">
              <svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z" stroke="currentColor" stroke-width="2"/>
              </svg>
            </button>
            <button class="action-icon-btn primary" (click)="addRelativeWithParent(hierarchyData.current)" title="Add Child">
              <svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <line x1="12" y1="5" x2="12" y2="19" stroke="currentColor" stroke-width="2"/>
                <line x1="5" y1="12" x2="19" y2="12" stroke="currentColor" stroke-width="2"/>
              </svg>
            </button>
          </div>
        </div>

        <!-- Spouse (Right) -->
        <div class="spouse-section" *ngIf="hierarchyData.spouse">
          <div class="level-label spouse-label">Spouse</div>
          <div class="relative-card" 
               [class.selected]="isSelected(hierarchyData.spouse)"
               (click)="selectRelative(hierarchyData.spouse)">
            <div class="relative-avatar" [attr.data-tooltip]="'Click on image to select this relative'">
              <img *ngIf="hierarchyData.spouse.profileImageUrl" class="avatar-img" [src]="hierarchyData.spouse.profileImageUrl" alt="Spouse avatar" (click)="selectAsCurrent(hierarchyData.spouse); $event.stopPropagation()" />
              <div class="avatar-circle" *ngIf="!hierarchyData.spouse.profileImageUrl" (click)="selectAsCurrent(hierarchyData.spouse); $event.stopPropagation()">
                {{ getInitials(hierarchyData.spouse) }}
              </div>
            </div>
            <div class="relative-info">
              <h3>
                <svg *ngIf="hierarchyData.spouse.isDeceased" class="deceased-icon" width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M12 2L13.09 8.26L20 9L13.09 9.74L12 16L10.91 9.74L4 9L10.91 8.26L12 2Z" fill="currentColor"/>
                  <path d="M19 15L19.5 17.5L22 18L19.5 18.5L19 21L18.5 18.5L16 18L18.5 17.5L19 15Z" fill="currentColor"/>
                  <path d="M5 15L5.5 17.5L8 18L5.5 18.5L5 21L4.5 18.5L2 18L4.5 17.5L5 15Z" fill="currentColor"/>
                </svg>
                {{ hierarchyData.spouse.firstName }} <span *ngIf="hierarchyData.spouse.middleName">{{ hierarchyData.spouse.middleName }}</span> {{ hierarchyData.spouse.lastName }}
              </h3>
              <p class="age-info" *ngIf="!hierarchyData.spouse.isDeceased">{{ calculateAge(hierarchyData.spouse.dateOfBirth) }} years old</p>
              <p class="deceased-info" *ngIf="hierarchyData.spouse.isDeceased">Deceased</p>
              <p>{{ getRelationshipType(hierarchyData.spouse, 'spouse') }}</p>
            </div>
            <div class="relative-actions">
              <button class="action-icon-btn" (click)="viewRelative(hierarchyData.spouse)" title="View Details">
                <svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M1 12S5 4 12 4S23 12 23 12S19 20 12 20S1 12 1 12Z" stroke="currentColor" stroke-width="2"/>
                  <circle cx="12" cy="12" r="3" stroke="currentColor" stroke-width="2"/>
                </svg>
              </button>
              <button class="action-icon-btn" (click)="openChat(hierarchyData.spouse)" title="Chat">
                <svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z" stroke="currentColor" stroke-width="2"/>
                </svg>
              </button>
              <button class="action-icon-btn primary" (click)="addRelativeWithParent(hierarchyData.spouse)" title="Add Child">
                <svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <line x1="12" y1="5" x2="12" y2="19" stroke="currentColor" stroke-width="2"/>
                  <line x1="5" y1="12" x2="19" y2="12" stroke="currentColor" stroke-width="2"/>
                </svg>
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Connection Line from Current to Children -->
    <div class="connection-line vertical" *ngIf="hierarchyData.children.length > 0"></div>

    <!-- Children Level -->
    <div class="hierarchy-level children-level" *ngIf="hierarchyData.children.length > 0">
      <div class="level-label children-label">Children</div>
      <div class="relatives-row">
        <div *ngFor="let child of hierarchyData.children" 
             class="relative-card" 
             [class.selected]="isSelected(child)"
             (click)="selectRelative(child)">
          <div class="relative-avatar" [attr.data-tooltip]="'Click on image to select this relative'">
            <img *ngIf="child.profileImageUrl" class="avatar-img" [src]="child.profileImageUrl" alt="Child avatar" (click)="selectAsCurrent(child); $event.stopPropagation()" />
            <div class="avatar-circle" *ngIf="!child.profileImageUrl" (click)="selectAsCurrent(child); $event.stopPropagation()">
              {{ getInitials(child) }}
            </div>
          </div>
          <div class="relative-info">
            <h3>
              <svg *ngIf="child.isDeceased" class="deceased-icon" width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M12 2L13.09 8.26L20 9L13.09 9.74L12 16L10.91 9.74L4 9L10.91 8.26L12 2Z" fill="currentColor"/>
                <path d="M19 15L19.5 17.5L22 18L19.5 18.5L19 21L18.5 18.5L16 18L18.5 17.5L19 15Z" fill="currentColor"/>
                <path d="M5 15L5.5 17.5L8 18L5.5 18.5L5 21L4.5 18.5L2 18L4.5 17.5L5 15Z" fill="currentColor"/>
              </svg>
              {{ child.firstName }} <span *ngIf="child.middleName">{{ child.middleName }}</span> {{ child.lastName }}
            </h3>
            <p class="age-info" *ngIf="!child.isDeceased">{{ calculateAge(child.dateOfBirth) }} years old</p>
            <p class="deceased-info" *ngIf="child.isDeceased">Deceased</p>
            <p>{{ getRelationshipType(child, 'child') }}</p>
          </div>
          <div class="relative-actions">
            <button class="action-icon-btn" (click)="viewRelative(child)" title="View Details">
              <svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M1 12S5 4 12 4S23 12 23 12S19 20 12 20S1 12 1 12Z" stroke="currentColor" stroke-width="2"/>
                <circle cx="12" cy="12" r="3" stroke="currentColor" stroke-width="2"/>
              </svg>
            </button>
            <button class="action-icon-btn" (click)="openChat(child)" title="Chat">
              <svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z" stroke="currentColor" stroke-width="2"/>
              </svg>
            </button>
            <button class="action-icon-btn primary" (click)="addRelativeWithParent(child)" title="Add Child">
              <svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <line x1="12" y1="5" x2="12" y2="19" stroke="currentColor" stroke-width="2"/>
                <line x1="5" y1="12" x2="19" y2="12" stroke="currentColor" stroke-width="2"/>
              </svg>
            </button>
          </div>
        </div>
      </div>
    </div>

  </div>

  <!-- Empty State -->
  <div *ngIf="!isLoading && !hierarchyData" class="empty-state">
    <svg width="64" height="64" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M17 21V19A4 4 0 0 0 13 15H5A4 4 0 0 0 1 19V21" stroke="currentColor" stroke-width="2"/>
      <circle cx="9" cy="7" r="4" stroke="currentColor" stroke-width="2"/>
      <path d="M23 21V19A4 4 0 0 0 19.5 15.5" stroke="currentColor" stroke-width="2"/>
      <path d="M16 3.13A4 4 0 0 1 16 10.87" stroke="currentColor" stroke-width="2"/>
    </svg>
    <h3>No hierarchy data found</h3>
    <p>Unable to load family hierarchy for this relative.</p>
  </div>
</div>

<!-- Chat Popup -->
<app-chat-popup
  [isVisible]="showChatPopup"
  [otherUserId]="chatOtherUserId"
  [otherUserName]="chatOtherUserName"
  [otherUserProfileImageUrl]="chatOtherUserProfileImageUrl"
  (closeChat)="closeChat()">
</app-chat-popup>
